import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { TInvoicesData } from 'store/api/cuverse-api/invoice/types/invoice-response.interface';
import { TPromocodeApplyData } from 'store/api/cuverse-api/promocode/types/promocode-response.interface';
import { TFetchStatus } from 'types/api/fetch-status.type';

import { fetchInvoiceThunkAction } from './invoice.thunk-actions';

export interface IInvoiceState {
  invoiceData: TInvoicesData | null;
  invoiceFetchStatus: TFetchStatus;
  invoiceError: string | null;

  promoError: string | null;
}

export const initialState: IInvoiceState = {
  invoiceData: null,
  invoiceFetchStatus: 'initial',
  invoiceError: null,

  promoError: null,
};

export const invoiceSlice = createSlice({
  name: 'invoice',
  initialState,
  reducers: {
    clearInvoiceStateAction: () => initialState,
    updateInvoiceStateAction: (state, action: PayloadAction<TPromocodeApplyData>) => {
      if (!state.invoiceData) return;

      const updatedInvoices = Object.entries(state.invoiceData.invoices).map(([key, invoice]) => {
        if (invoice.isTrial) return [key, invoice];

        return [key, { ...invoice, discount: action.payload.discount }];
      });

      state.invoiceData = {
        ...state.invoiceData,
        ...action.payload,
        invoices: Object.fromEntries(updatedInvoices),
        costPriceBtc: action.payload.priceBtc,
        costPriceUsd: action.payload.priceUsd,
      };
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchInvoiceThunkAction.pending, (state) => {
      state.invoiceFetchStatus = 'pending';
      state.invoiceError = null;
    });
    builder.addCase(
      fetchInvoiceThunkAction.fulfilled,
      (state, { payload }: PayloadAction<TInvoicesData>) => {
        state.invoiceFetchStatus = 'fulfilled';
        state.invoiceData = payload;
      },
    );
    builder.addCase(fetchInvoiceThunkAction.rejected, (state, error) => {
      state.invoiceFetchStatus = 'rejected';
      state.invoiceError = JSON.stringify(error);
    });
  },
});

export const { clearInvoiceStateAction, updateInvoiceStateAction } = invoiceSlice.actions;
export const invoiceReducer = invoiceSlice.reducer;
